import React from 'react';
import { Editor } from 'draft-js';

function blockStyleFn(contentBlock) {
  const type = contentBlock.getType();

  if (type === 'unstyled') {
    return 'lh-copy f5';
  }
}

const BaseEditor = (props) => {
  return <Editor {...props} blockStyleFn={blockStyleFn} />
}

export default BaseEditor;


/** WEBPACK FOOTER **
 ** ./src/components/pages/StyledEditor.js
 **/